var _circle, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add timer function block") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 22,
    cx: 40,
    cy: 40,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    x2: 40,
    y1: 40,
    y2: 26,
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    x2: 48,
    y1: 40,
    y2: 46,
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 40,
    x2: 20,
    y2: 40,
    stroke: "#000",
    strokeWidth: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 40,
    x2: 80,
    y2: 40,
    stroke: "#000",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.e5fb90320139378521838eaeff4ce322.svg";
export { ForwardRef as ReactComponent };